// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"08ff1cb6","483":"a5cb4286"}[chunkId] + ".chunk.js";
};